var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"businesses_banner",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm8":""}},[_c('Breadcrumb')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }